module.exports = __webpack_public_path__ + "img/fig.d8ca88bd.jpg";